import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './UnpinActivity.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnpinMutationVariables = Types.Exact<{
  targetGlobalId: Types.Scalars['GlobalID']['input'];
}>;


export type UnpinMutation = (
  { __typename?: 'Mutation' }
  & { postingsUnpinActivityByTarget?: Types.Maybe<(
    { __typename?: 'PostingsUnpinActivityResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'PostingsError' }
      & Pick<Types.PostingsError, 'message' | 'details'>
    )> }
  )> }
);


export type UnpinMutationFn = Apollo.MutationFunction<UnpinMutation, UnpinMutationVariables>;

/**
 * __useUnpinMutation__
 *
 * To run a mutation, you first call `useUnpinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinMutation, { data, loading, error }] = useUnpinMutation({
 *   variables: {
 *      targetGlobalId: // value for 'targetGlobalId'
 *   },
 * });
 */
export function useUnpinMutation(baseOptions?: Apollo.MutationHookOptions<UnpinMutation, UnpinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpinMutation, UnpinMutationVariables>(Operations.unpin, options);
      }
export type UnpinMutationHookResult = ReturnType<typeof useUnpinMutation>;
export type UnpinMutationResult = Apollo.MutationResult<UnpinMutation>;
export type UnpinMutationOptions = Apollo.BaseMutationOptions<UnpinMutation, UnpinMutationVariables>;